import React, { useState, useContext } from 'react'
import Consulta from './Types/consulta'
import Cadastro from './Types/cadastro'
import TabNavigation from '../General/TabNavigation'
import { UserContext } from '../../contexts/userProvider'

const Usuarios = () => {
  const { isAdmin } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState('consulta')

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
  }

  const tabs = [
    {
      key: 'consulta',
      label: 'Consulta',
      icon: 'user',
      content: <Consulta onTabChange={handleTabChange} />
    },
    // Cadastro/edição (inclui NÍVEL) é só admin; gerente só ativa/desativa.
    ...(isAdmin ? [{
      key: 'cadastro',
      label: 'Cadastro',
      icon: 'config',
      content: <Cadastro onTabChange={handleTabChange} />
    }] : [])
  ]

  return (
    <div className='w-full min-h-full'>
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="default"
      />
    </div>
  )
}

export default Usuarios;
